// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"873f9376","191":"19378b02","258":"fe990421","262":"b72900cc","318":"dd780198","474":"b8efe550","570":"84f6ab4c","787":"44f5ae0a","968":"e445c6ac"}[chunkId] + ".chunk.js";
};